import PropTypes from 'prop-types';
import {Message} from 'semantic-ui-react';

import styles from './ProjectInformationBanner.module.scss';

const BANNER_TYPES = {
  BLOCKED: 'blocked',
  READ_ONLY: 'readOnly',
  WARNING: 'warning',
  INFO: 'info',
};

const ProjectInformationBanner = ({type, projectName, message, metadata}) => {
  const config = {
    [BANNER_TYPES.BLOCKED]: {
      icon: 'attention',
      negative: true,
      header: `The site ${projectName} has been blocked${
        metadata?.timestamp ? ` since ${new Date(metadata.timestamp).toLocaleString()}` : ''
      }`,
      content: (
        <>
          The site has been blocked for the following reason: <strong>{metadata?.reason}</strong>. A
          blocked site is offline and returns a "503 - Application not available page" when accessed
          while all the resources of the site remain.
        </>
      ),
    },
    [BANNER_TYPES.READ_ONLY]: {
      icon: 'info circle',
      warning: true,
      header: `Project ${projectName} information is only editable by the owner or members of the admin group.`,
      content: message,
    },
    [BANNER_TYPES.WARNING]: {
      icon: 'warning sign',
      warning: true,
      header: 'Warning',
      content: message,
    },
    [BANNER_TYPES.INFO]: {
      icon: 'info',
      info: true,
      header: 'Information',
      content: message,
    },
  };

  const bannerConfig = config[type];

  return (
    <div className={styles.Banner}>
      <Message
        attached
        icon={bannerConfig.icon}
        negative={bannerConfig.negative}
        warning={bannerConfig.warning}
        info={bannerConfig.info}
        size="small"
        header={bannerConfig.header}
        content={bannerConfig.content}
      />
    </div>
  );
};

ProjectInformationBanner.propTypes = {
  type: PropTypes.oneOf(Object.values(BANNER_TYPES)).isRequired,
  projectName: PropTypes.string.isRequired,
  message: PropTypes.node,
  metadata: PropTypes.shape({
    reason: PropTypes.string,
    timestamp: PropTypes.string,
  }),
};

export {BANNER_TYPES};
export default ProjectInformationBanner;
